export default __webpack_public_path__ + "static/media/gallery_00.3e8893e7.jpg";